import { SegmentsStream } from '@mi-front/ui';
import { useTimezone } from '../../../../../../core/hooks';
import { PreviewBrush } from '../../components/preview/PreviewBrush';
import { PreviewFocusMarkers } from '../../components/preview/PreviewFocusMarkers';
import { PreviewWrapper } from '../../components/preview/elements';
import { STREAM_SCREEN_CONFIG } from '../../config';
import { useStreamSegmentsList } from '../../hooks/segments/useStreamSegmentsQuery';
import { useStreamUserDefinedRange } from '../../stores/stream-screen.store';

export const AudioPreview = () => {
  const segments = useStreamSegmentsList();
  const range = useStreamUserDefinedRange();

  return (
    <PreviewWrapper>
      <SegmentsStream
        fadeSides
        compressed
        tz={useTimezone()}
        height={STREAM_SCREEN_CONFIG.previewHeightExpanded}
        range={range}
        segments={segments}
        disableHtmlEvents
        renderSvg={() => <PreviewBrush />}
        renderHtml={() => <PreviewFocusMarkers />}
      />
    </PreviewWrapper>
  );
};
